// Readers for an action's `evidenceConfig` — the regulation pack's `action.evidence` object,
// persisted verbatim by the backend and handed to us untyped. Keeping the narrowing here means the
// evidence controls stay pack-driven: nothing in the UI names LL144 or any other regulation.

export type AttestationDateRequirement = 'required' | 'optional' | 'none';

/**
 * Whether this action wants the date its document was produced, and how insistently.
 *
 * `'none'` (the default) is what every pack that has not opted in returns, so existing document
 * actions render exactly as before.
 */
export const attestationDateRequirement = (
  evidenceConfig?: Record<string, unknown> | null
): AttestationDateRequirement => {
  const value = evidenceConfig?.attestationDate;
  return value === 'required' || value === 'optional' ? value : 'none';
};

/** The pack's label for that date (e.g. "Audit date"), falling back to a neutral one. */
export const attestationDateLabel = (
  evidenceConfig?: Record<string, unknown> | null,
  fallback = 'Date'
): string => {
  const value = evidenceConfig?.attestationDateLabel;
  return typeof value === 'string' && value.trim() ? value : fallback;
};

/**
 * The document category to upload under. Pack document evidence uses a `categories` array (e.g.
 * `{ kind: 'document', categories: ['OTHER'] }`); we use the first entry.
 */
export const evidenceDocumentCategory = (
  evidenceConfig?: Record<string, unknown> | null
): string | undefined => {
  const categories = evidenceConfig?.categories;
  return Array.isArray(categories) && typeof categories[0] === 'string'
    ? categories[0]
    : undefined;
};
